// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"f27d14b0","403":"4e45def7","444":"9d37edc6","453":"5f3842d5","879":"01d84858","960":"012ff51d"}[chunkId] + ".chunk.js";
};